import { render, staticRenderFns } from "./WxPayBefore.vue?vue&type=template&id=5f15e6a8&scoped=true"
import script from "./WxPayBefore.vue?vue&type=script&lang=js"
export * from "./WxPayBefore.vue?vue&type=script&lang=js"
import style0 from "./WxPayBefore.vue?vue&type=style&index=0&id=5f15e6a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f15e6a8",
  null
  
)

export default component.exports